import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UISelect from 'UIComponents/input/UISelect';
import { isIE11, isEdge, isFirefox, isSafari } from 'UIComponents/utils/BrowserTest';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
const EDGE = 'edge';
const INTERNET_EXPLORER = 'internetExplorer';
const FIREFOX = 'firefox';
const SAFARI = 'safari';
const SAFARI_IOS = 'safariIos';
const CHROME = 'chrome';
const CHROME_ANDROID = 'chromeAndroid';
const CHROME_IOS = 'chromeIos';
const UNSUPPORTED_BROWSER = 'unsupportedBrowser';
const BROWSER_NOT_LISTED = 'notListed';
const KNOWN_BROWSERS = [CHROME, CHROME_ANDROID, CHROME_IOS, SAFARI, SAFARI_IOS, INTERNET_EXPLORER, EDGE, FIREFOX];
const ALL_BROWSERS = [...KNOWN_BROWSERS, BROWSER_NOT_LISTED];

const isChrome = () => {
  const lowercasedUserAgent = window.navigator ? navigator.userAgent.toLowerCase() : '';
  return lowercasedUserAgent.includes('chrome/');
};

export const isBrowserSupported = browser => {
  return browser !== UNSUPPORTED_BROWSER && browser !== BROWSER_NOT_LISTED;
};
export const getDropdownOptions = browser => {
  return isBrowserSupported(browser) ? ALL_BROWSERS : KNOWN_BROWSERS;
};
export const isIos = ua => !!ua && /ipad|iphone|ipod/.test(ua.toLowerCase());
export const isAndroid = ua => !!ua && /android/i.test(ua.toLowerCase());
export const getUserBrowser = () => {
  if (isIE11()) {
    return INTERNET_EXPLORER;
  } else if (isEdge()) {
    return EDGE;
  } else if (isFirefox()) {
    return FIREFOX;
  } else if (isSafari()) {
    if (isIos(navigator.userAgent)) {
      return SAFARI_IOS;
    }

    return SAFARI;
  } else if (isChrome()) {
    if (isAndroid(navigator.userAgent)) {
      return CHROME_ANDROID;
    }

    if (isIos(navigator.userAgent)) {
      return CHROME_IOS;
    }

    return CHROME;
  }

  return UNSUPPORTED_BROWSER;
};

const ThirdPartyCookiesInstructions = () => {
  const detectedBrowser = getUserBrowser();
  const dropdownOptions = getDropdownOptions(detectedBrowser);
  const [selectedBrowser, updateSelectedBrowser] = useState(detectedBrowser);
  const detectedBrowserSupported = isBrowserSupported(detectedBrowser);
  const selectedBrowserSupported = isBrowserSupported(selectedBrowser);

  const handleBrowserSelect = ({
    target: {
      value
    }
  }) => updateSelectedBrowser(value.value);

  return /*#__PURE__*/_jsxs("div", {
    children: [!detectedBrowserSupported && /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `app.cookieModal.${UNSUPPORTED_BROWSER}.subtext_jsx`,
      elements: {
        Link: UILink,
        P: ({
          children
        }) => /*#__PURE__*/_jsx("p", {
          children: children
        })
      },
      options: {
        linkProps: {
          external: true,
          use: 'on-bright',
          href: 'https://knowledge.hubspot.com/resources/which-browsers-are-supported-by-hubspot'
        }
      }
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(UISelect, {
        menuWidth: 250,
        className: "p-left-0 m-bottom-1",
        searchable: false,
        buttonUse: "transparent",
        options: dropdownOptions.map(key => ({
          value: key,
          dropdownText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `app.cookieModal.${key}.name`
          }),
          buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `app.cookieModal.${key}.name`
          })
        })),
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `app.cookieModal.${selectedBrowser}.name`
        }),
        onSelectedOptionChange: handleBrowserSelect
      })
    }), selectedBrowserSupported && /*#__PURE__*/_jsx("ol", {
      className: "p-left-4",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `app.cookieModal.${selectedBrowser}.instructions`
      })
    }), detectedBrowserSupported && !selectedBrowserSupported && /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `app.cookieModal.${selectedBrowser}.subtext_jsx`,
      elements: {
        Link: UILink,
        P: ({
          children
        }) => /*#__PURE__*/_jsx("p", {
          children: children
        })
      },
      options: {
        linkProps: {
          external: true,
          use: 'on-bright',
          href: 'https://knowledge.hubspot.com/resources/which-browsers-are-supported-by-hubspot'
        }
      }
    })]
  });
};

export default ThirdPartyCookiesInstructions;